<template>
    <v-app id="nowyu" toolbar footer>
        <main-navigation></main-navigation>
        <main-toolbar></main-toolbar>


        <main>
            <v-container fluid pl-5 pr-5>
                <main-breadcrumb></main-breadcrumb>
                <v-slide-y-transition mode="out-in">
                    <router-view></router-view>
                </v-slide-y-transition>
            </v-container>
            <main-footer></main-footer>
        </main>
    </v-app>
</template>

<script>
    import MainNavigation from '../components/MainNavigation';
    import MainToolbar from '../components/MainToolbar';
    import MainFooter from '../components/MainFooter';

    export default {
        components: {
            MainNavigation,
            MainToolbar,
            MainFooter,
        },
        methods: {
        },
    };
</script>

<style lang="stylus">
    #main-navigation
        border-width: 0pt;
</style>



// WEBPACK FOOTER //
// MainLayout.vue?0958dfc4